import { Chakra } from "@airhelp/react-ui-components";
import config from "config/config";
import { COLOR_BROWN } from "modules/storyblok/templates/AirHelpScore/styles";
import type { ScoreTagProps } from "./ScoreTag.d";

const { Flex, Image, Text } = Chakra;

const ScoreTag = ({ index, score, size = "sm" }: ScoreTagProps) => {
  let scoreTagColor = "warning.500";

  if (index === 1) {
    scoreTagColor = "greyscale.500";
  } else if (index === 2) {
    scoreTagColor = COLOR_BROWN;
  }

  const tagProps =
    size === "sm"
      ? {
          py: 1.5,
          px: 2,
        }
      : {
          size: "lg",
          px: 3,
          h: "42px",
          maxW: 36,
          margin: "0 auto",
        };

  const image =
    size === "sm" ? null : (
      <Image src={`${config.staticUrl}/i/airhelp-score/score-top-place-icon-${index + 1}.svg`} mr={2} />
    );

  const label =
    size === "sm" ? (
      <Text fontSize="sm">{score.toFixed(2)}/10</Text>
    ) : (
      <Text fontSize="lg">{score.toFixed(2)} / 10</Text>
    );

  return (
    <Flex align="center" bg={scoreTagColor} borderRadius="md" color="white" {...tagProps}>
      {image}
      {label}
    </Flex>
  );
};

export default ScoreTag;
